export default __webpack_public_path__ + "static/media/etherscan.b68fabfd.webp";